import React from 'react'
import { Flex, Image } from '@chatterbug/aaron'

export type Props = {
  icon: string
  label: string
}

const LevelWrapupStatsItem: React.FC<Props> = ({ icon, label }) => {
  return (
    <Flex
      alignItems="center"
      justifyContent={{ _: 'center', tablet: 'flex-start' }}
    >
      <Image src={icon} width={24} mr="1x" alt="" />
      {label}
    </Flex>
  )
}

export default LevelWrapupStatsItem
